module.exports = __webpack_public_path__ + "img/04.4ce9d2e9.png";